<template>
    <div class="boxed-text py-10 lg:py-20">
        <component
            :is="vercelStegaCleanAll(headingLevel)"
            class="mb-2 text-center text-lg lg:mb-8 lg:text-3xl"
            v-if="title">
            {{ title }}
        </component>
        <div class="grid grid-cols-1 lg:mb-4 lg:grid-cols-2 lg:gap-10">
            <div
                v-for="(column, index) in [firstColumn, secondColumn]"
                :key="index"
                class="sanity-content relative w-full text-[16px] transition-all ease-in-out lg:block"
                :class="{
                    'limited-height': !showFullContent,
                    'full-height': showFullContent,
                    'hidden lg:block': !showFullContent && index === 1,
                }">
                <SanityContent v-if="column" :blocks="column.body" :serializers="serializers" />
                <div
                    v-if="!showFullContent"
                    class="absolute bottom-0 h-10 w-full bg-gradient-to-t from-white to-transparent"></div>
            </div>
        </div>
        <div class="text-center">
            <button
                @click="showFullContent = true"
                class="border-b-2 border-current text-sm font-semibold transition-all duration-500 ease-in-out hover:border-green-500 hover:text-green-500 hover:duration-200"
                v-show="!showFullContent">
                Meer
            </button>
        </div>
        <div :class="{ '!hidden': !showFullContent }" class="text-[13px] leading-[23px] lg:text-base lg:leading-7">
            {{ text }}
        </div>
    </div>
</template>

<script setup lang="ts">
    import { vercelStegaCleanAll } from '@sanity/client/stega';
    import { extractFaqFromPortableText } from '~/utils/seo';
    const props = defineProps({
        title: String,
        firstColumn: Object,
        secondColumn: Object,
        text: String,
        headingLevel: {
            type: String,
            default: 'h2',
            validator: value => ['h1', 'h2', 'h3', 'h4'].includes(value),
        },
    });

    let showFullContent = ref(false);

    useFaqPageSchema(() => [
        ...extractFaqFromPortableText(props.firstColumn?.body),
        ...extractFaqFromPortableText(props.secondColumn?.body),
    ]);

    const serializers = {
        types: {
            button: resolveComponent('Button'),
            spacing: resolveComponent('BlockSpacing'),
        },
    };
</script>

<style scoped>
    .sanity-content {
        overflow: hidden;
        font-family: 'Mori';
    }

    .limited-height {
        max-height: 120px;
    }

    .full-height {
        max-height: 100%;
    }

    div.sanity-content {
        line-height: 24px;
        @media (max-width: 768px) {
            font-size: 13px;
        }
    }
</style>
